import axios from "axios";
import Swal from 'sweetalert2';
const userName = localStorage.getItem('username');
const ipAddress = '194.238.17.244';
const userLocation = localStorage.getItem('userLocation');
const baseUrl = 'https://drghis.mgmebuild.com/api/';
const baseimgUrl = 'https://drghis.mgmebuild.com/';
export { baseUrl, baseimgUrl, userName, ipAddress, userLocation };
export default axios;
